module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('loading', {
    attrs: {
      "show": _vm.showProcessing,
      "label": "Processing"
    }
  }), _vm._v(" "), _c('overview-layout', {
    ref: "overview",
    attrs: {
      "tableCfg": _vm.tableCfg
    },
    scopedSlots: _vm._u([{
      key: "ExtraOptions",
      fn: function(props) {
        return [_c('b-dropdown', {
          attrs: {
            "variant": "default",
            "size": "sm"
          }
        }, [_c('template', {
          slot: "button-content"
        }, [_c('i', {
          staticClass: "fa fa-cog"
        })]), _vm._v(" "), _c('b-dropdown-item', {
          on: {
            "click": function($event) {
              _vm.exportSelection('/contracts/download_report', 'Contracts.xlsx')
            }
          }
        }, [_vm._v("Export Selection")]), _vm._v(" "), (false) ? _c('b-dropdown-item', {
          on: {
            "click": function($event) {
              _vm.exportSelection('/contracts/download_paymentstatus', 'Balance_to_date.xlsx')
            }
          }
        }, [_vm._v("Export Payment Status")]) : _vm._e(), _vm._v(" "), _c('b-dropdown-item', {
          on: {
            "click": function($event) {
              _vm.$refs.modalExportPaymentStatus.show()
            }
          }
        }, [_vm._v("Export Payment Status")]), _vm._v(" "), _c('b-dropdown-item', {
          on: {
            "click": function($event) {
              _vm.$refs.modalImportDreamApply.show()
            }
          }
        }, [_vm._v("Import DreamApply")]), _vm._v(" "), (false) ? _c('b-dropdown-item', {
          on: {
            "click": function($event) {
              _vm.$refs.modalUpload.show()
            }
          }
        }, [_vm._v("Import Contracts")]) : _vm._e(), _vm._v(" "), _c('b-dropdown-item', {
          on: {
            "click": function($event) {
              _vm.$refs.modalUploadBankInfo.show()
            }
          }
        }, [_vm._v("Import Bank Info")])], 2), _vm._v(" "), (_vm.hasSelections() && _vm.privAdministrator) ? _c('b-dropdown', {
          attrs: {
            "variant": "default",
            "size": "sm"
          }
        }, [_c('template', {
          slot: "button-content"
        }, [_c('i', {
          staticClass: "fa fa-rocket"
        }), _vm._v(" Batch\n          ")]), _vm._v(" "), _c('b-dropdown-item', {
          on: {
            "click": function($event) {
              _vm.$refs.modalBulkEdit.show()
            }
          }
        }, [_vm._v("Bulk Edit")]), _vm._v(" "), _c('b-dropdown-item', {
          on: {
            "click": function($event) {
              _vm.$refs.modalSendBankInfoRequestOk.show()
            }
          }
        }, [_vm._v("Email bank info request scholarships")]), _vm._v(" "), _c('b-dropdown-item', {
          on: {
            "click": function($event) {
              _vm.$refs.modalSendPFStatusOk.show()
            }
          }
        }, [_vm._v("Send PF Status")])], 2) : _vm._e()]
      }
    }])
  }, [_c('template', {
    slot: "AdvancedFilter"
  }, [_c('b-form', {
    ref: "form",
    staticClass: "offset-md-1",
    attrs: {
      "autocomplete": "off"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('detail-field', {
    staticClass: "col-md-3",
    attrs: {
      "label": "Student",
      "field": "student_id",
      "optionListApiUrl": '/students/choice/',
      "rec": _vm.searchRec,
      "vvalidate": "ok",
      "validator": _vm.validator
    },
    on: {
      "enter": _vm.doFilter
    }
  }), _vm._v(" "), _c('detail-field', {
    staticClass: "col-md-3",
    attrs: {
      "label": "Status",
      "field": "contract_status_id",
      "optionListApiUrl": '/contract_status/choice/',
      "rec": _vm.searchRec,
      "vvalidate": "ok",
      "validator": _vm.validator
    },
    on: {
      "enter": _vm.doFilter
    }
  }), _vm._v(" "), _c('detail-field', {
    staticClass: "col-md-3",
    attrs: {
      "label": "Type",
      "field": "scholarship_type",
      "optionListApiUrl": '/scholarships_type/choice/',
      "rec": _vm.searchRec,
      "vvalidate": "ok",
      "validator": _vm.validator
    },
    on: {
      "enter": _vm.doFilter
    }
  }), _vm._v(" "), _c('detail-field', {
    staticClass: "col-md-3",
    attrs: {
      "label": "EU/Non-EU",
      "field": "scholarship_region",
      "optionListApiUrl": '/scholarships_region/choice/',
      "rec": _vm.searchRec,
      "vvalidate": "ok",
      "validator": _vm.validator
    },
    on: {
      "enter": _vm.doFilter
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('detail-field', {
    staticClass: "col-md-3",
    attrs: {
      "label": "Program",
      "field": "program_id",
      "optionListApiUrl": '/programs/choice/',
      "rec": _vm.searchRec,
      "vvalidate": "ok",
      "validator": _vm.validator
    },
    on: {
      "enter": _vm.doFilter
    }
  }), _vm._v(" "), _c('detail-field', {
    staticClass: "col-md-3",
    attrs: {
      "label": "University y1",
      "field": "y1_university_id",
      "optionListApiUrl": '/universities/choice/',
      "rec": _vm.searchRec,
      "vvalidate": "ok",
      "validator": _vm.validator
    },
    on: {
      "enter": _vm.doFilter
    }
  }), _vm._v(" "), _c('detail-field', {
    staticClass: "col-md-3",
    attrs: {
      "label": "University y2",
      "field": "y2_university_id",
      "optionListApiUrl": '/universities/choice/',
      "rec": _vm.searchRec,
      "vvalidate": "ok",
      "validator": _vm.validator
    },
    on: {
      "enter": _vm.doFilter
    }
  }), _vm._v(" "), _c('detail-field', {
    staticClass: "col-md-3",
    attrs: {
      "label": "Date",
      "type": "date",
      "field": "date",
      "rec": _vm.searchRec,
      "vvalidate": "ok",
      "validator": _vm.validator
    },
    on: {
      "enter": _vm.doFilter
    }
  }), _vm._v(" "), _c('detail-field', {
    staticClass: "col-md-3",
    attrs: {
      "label": "Open",
      "field": "open",
      "optionList": _vm.boolFilterOptions,
      "rec": _vm.searchRec,
      "vvalidate": "ok",
      "validator": _vm.validator
    },
    on: {
      "enter": _vm.doFilter
    }
  }), _vm._v(" "), _c('detail-field', {
    staticClass: "col-md-3",
    attrs: {
      "label": "Intake",
      "field": "intake",
      "optionListApiUrl": '/contracts_intake/choice/',
      "rec": _vm.searchRec,
      "vvalidate": "ok",
      "validator": _vm.validator
    },
    on: {
      "enter": _vm.doFilter
    }
  }), _vm._v(" "), _c('detail-field', {
    staticClass: "col-md-3",
    attrs: {
      "label": "Round",
      "field": "application_round",
      "optionListApiUrl": '/contracts_round/choice/',
      "rec": _vm.searchRec,
      "vvalidate": "ok",
      "validator": _vm.validator
    },
    on: {
      "enter": _vm.doFilter
    }
  }), _vm._v(" "), _c('detail-field', {
    staticClass: "col-md-3",
    attrs: {
      "label": "Instalments",
      "field": "instalments",
      "optionList": _vm.boolFilterOptions,
      "rec": _vm.searchRec,
      "vvalidate": "ok",
      "validator": _vm.validator
    },
    on: {
      "enter": _vm.doFilter
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('detail-field', {
    staticClass: "col-md-6",
    attrs: {
      "label": "Bank info requested before",
      "type": "date",
      "field": "bankinfo_requested_before",
      "rec": _vm.searchRec,
      "vvalidate": "ok",
      "validator": _vm.validator
    },
    on: {
      "enter": _vm.doFilter
    }
  }), _vm._v(" "), _c('detail-field', {
    staticClass: "col-md-6",
    attrs: {
      "label": "Bank info updated before",
      "type": "date",
      "field": "bankinfo_updated_before",
      "rec": _vm.searchRec,
      "vvalidate": "ok",
      "validator": _vm.validator
    },
    on: {
      "enter": _vm.doFilter
    }
  })], 1)])], 1)], 2), _vm._v(" "), _c('b-modal', {
    ref: "modalBulkEdit",
    attrs: {
      "size": "lg",
      "title": "Bulk Edit",
      "ok-title": "Apply",
      "close-title": "Cancel"
    },
    on: {
      "ok": function($event) {
        _vm.bulkOk('/contracts/bulk_edit')
      }
    }
  }, [_c('b-form', {
    ref: "form",
    staticClass: "offset-md-1",
    attrs: {
      "autocomplete": "off"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('detail-field', {
    staticClass: "col-md-10",
    attrs: {
      "label": "Status Date",
      "field": "contract_status_date",
      "rec": _vm.bulkRec,
      "type": "date",
      "vvalidate": "ok",
      "validator": _vm.validator
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('detail-field', {
    staticClass: "col-md-10",
    attrs: {
      "label": "Y1 Finished",
      "field": "year1_finished",
      "rec": _vm.bulkRec,
      "type": "boolean",
      "hasNull": true,
      "vvalidate": "ok",
      "validator": _vm.validator
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('detail-field', {
    staticClass: "col-md-10",
    attrs: {
      "label": "University Y2",
      "field": "y2_university_id",
      "optionListApiUrl": '/universities/choice/',
      "rec": _vm.bulkRec,
      "vvalidate": "ok",
      "validator": _vm.validator
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('detail-field', {
    staticClass: "col-md-10",
    attrs: {
      "label": "Y2 Finished",
      "field": "year2_finished",
      "rec": _vm.bulkRec,
      "type": "boolean",
      "hasNull": true,
      "vvalidate": "ok",
      "validator": _vm.validator
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('detail-field', {
    staticClass: "col-md-10",
    attrs: {
      "label": "Start Date",
      "field": "start_date",
      "rec": _vm.bulkRec,
      "type": "date",
      "vvalidate": "ok",
      "validator": _vm.validator
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('detail-field', {
    staticClass: "col-md-10",
    attrs: {
      "label": "Contract Sent",
      "field": "contract_sent_date",
      "rec": _vm.bulkRec,
      "type": "date",
      "vvalidate": "ok",
      "validator": _vm.validator
    }
  })], 1)])], 1), _vm._v(" "), _c('b-modal', {
    ref: "modalExportPaymentStatus",
    attrs: {
      "size": "lg",
      "title": "Export Payment Status",
      "ok-title": "Export",
      "close-title": "Cancel",
      "ok-disabled": false
    },
    on: {
      "ok": _vm.exportPaymentStatus
    }
  }, [_c('b-form', {
    ref: "form",
    staticClass: "offset-md-1",
    attrs: {
      "autocomplete": "off"
    }
  }, [_c('detail-field', {
    staticClass: "col-md-6",
    attrs: {
      "label": "From",
      "type": "date",
      "field": "start",
      "rec": _vm.exportPaymentRec,
      "vvalidate": "ok",
      "validator": _vm.validator
    }
  }), _vm._v(" "), _c('detail-field', {
    staticClass: "col-md-6",
    attrs: {
      "label": "Until",
      "type": "date",
      "field": "end",
      "rec": _vm.exportPaymentRec,
      "vvalidate": "ok",
      "validator": _vm.validator
    }
  })], 1)], 1), _vm._v(" "), _c('b-modal', {
    ref: "modalImportDreamApply",
    attrs: {
      "size": "lg",
      "title": "Import DreamApply",
      "ok-title": "Import",
      "close-title": "Cancel",
      "ok-disabled": false
    },
    on: {
      "ok": _vm.importDreamApply
    }
  }, [_c('b-form', {
    ref: "form",
    staticClass: "offset-md-1",
    attrs: {
      "autocomplete": "off"
    }
  }, [_c('detail-field', {
    staticClass: "col-md-12",
    attrs: {
      "label": "Academic Year",
      "type": "number",
      "field": "academic_year",
      "rec": _vm.importDreamApplyRec,
      "vvalidate": "ok",
      "validator": _vm.validator
    }
  }), _vm._v(" "), (false) ? _c('detail-field', {
    staticClass: "col-md-12",
    attrs: {
      "label": "Enter value 1 to check for all updates (slow)",
      "type": "number",
      "field": "updates_in_last_days",
      "rec": _vm.importDreamApplyRec,
      "vvalidate": "ok",
      "validator": _vm.validator
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('b-modal', {
    ref: "modalUpload",
    attrs: {
      "size": "lg",
      "title": "Upload spreadsheet",
      "ok-title": "Upload",
      "close-title": "Cancel",
      "ok-disabled": _vm.documentToUpload === null || _vm.documentToUpload === undefined
    },
    on: {
      "ok": _vm.uploadExcel
    }
  }, [_c('b-form', {
    ref: "form",
    staticClass: "offset-md-1",
    attrs: {
      "autocomplete": "off"
    }
  }, [_c('b-form-file', {
    ref: "fileinput",
    staticClass: "col-md-10",
    attrs: {
      "placeholder": " ",
      "accept": ".xlsx"
    },
    model: {
      value: (_vm.documentToUpload),
      callback: function($$v) {
        _vm.documentToUpload = $$v
      },
      expression: "documentToUpload"
    }
  })], 1)], 1), _vm._v(" "), _c('b-modal', {
    ref: "modalUploadBankInfo",
    attrs: {
      "size": "lg",
      "title": "Upload bank info XLSX or ZIP",
      "ok-title": "Upload",
      "close-title": "Cancel",
      "ok-disabled": _vm.documentToUpload === null || _vm.documentToUpload === undefined
    },
    on: {
      "ok": _vm.uploadBankInfo
    }
  }, [_c('b-form', {
    ref: "form",
    staticClass: "offset-md-1",
    attrs: {
      "autocomplete": "off"
    }
  }, [_c('b-form-file', {
    ref: "fileinput",
    staticClass: "col-md-10",
    attrs: {
      "placeholder": " ",
      "accept": ".xlsx,.zip"
    },
    model: {
      value: (_vm.documentToUpload),
      callback: function($$v) {
        _vm.documentToUpload = $$v
      },
      expression: "documentToUpload"
    }
  })], 1)], 1), _vm._v(" "), _c('b-modal', {
    ref: "modalSendBankInfoRequestOk",
    attrs: {
      "title": "Send Bank Info Request",
      "ok-title": "Yes",
      "close-title": "No"
    },
    on: {
      "ok": function($event) {
        _vm.$refs.overview.runBatch(_vm.sendBankInfoRequest, 'application_number')
      }
    }
  }, [_vm._v("\n    Are you sure you want to request the bank info for the selected items?\n  ")]), _vm._v(" "), _c('b-modal', {
    ref: "modalSendPFStatusOk",
    attrs: {
      "title": "Send Participation Fee Status",
      "ok-title": "Yes",
      "close-title": "No"
    },
    on: {
      "ok": function($event) {
        _vm.$refs.overview.runBatch(_vm.sendPFStatus, 'application_number')
      }
    }
  }, [_vm._v("\n    Are you sure you want to send the participation fee status email for the selected items?\n  ")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-75b8c612"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Contract/Overview.vue
// module id = 712
// module chunks = 1